// extracted by mini-css-extract-plugin
module.exports = {"bn-collection-title":"collection-title-with-arrow-m__bn-collection-title__34I5_","en-collection-title":"collection-title-with-arrow-m__en-collection-title__2-f9y"};